var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_c('alert-widget-settings-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }